import React from 'react'
import { Button, GoogleMapLocation } from '../../components'
import styles from './styles.module.css'

const EventDetails = () => {
  const venueUrl = 'https://yandex.by/maps/org/kompleks_bogdanovichey_dvor_stayki/163626036730/?ll=27.432636%2C54.479137&z=16'

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          <div className={styles.locationIcon}>📍</div>
          <h2 className={styles.title}>Локация нашего торжества</h2>
          <div className={styles.divider}></div>
          <p className={styles.subtitle}>Усадьба Богдановичей "Двор Стайки"</p>
        </div>

        <div className={styles.mapContainer}>
          <GoogleMapLocation className={styles.map} />
        </div>

        <div className={styles.actions}>
          <Button 
            text="Открыть в Яндекс картах"
            onClick={() => window.open(venueUrl)}
            className={styles.mapButton}
          />
          <p className={styles.note}>
            Нажмите, чтобы построить маршрут к месту проведения
          </p>
        </div>
      </div>
    </div>
  )
}

export default EventDetails